import * as CryptoJS from 'crypto-js';

export class Cifrado {

  private key: string;
  private iv: string;
  constructor() 
  {
    this.key = '321569853215698532156985';
    this.iv = '00000000';
  }

  generarToken()
  {
      var date = new Date();
      var random = Math.floor((Math.random() * 1000) + 1);
      var token = date.getFullYear() + '|';
      token += (date.getMonth() + 1) + '|';
      token += date.getDate() + '|';
      token += date.getHours() + '|';
      token += date.getMinutes() + '|';
      token += date.getSeconds() + '|';
      token += 'CIDWD' + '|';
      token += 'ca9281812ab022dbdc8061700d6be4c5' + '|';
      token += 'CIDWD' + '|';
      token += random + '|';
      var cifrado = new Cifrado();
      token = cifrado.encriptar(token);
      cifrado = null;
      token = encodeURIComponent(token);
      token = token.replace(/%2F/g, '%252F');
      token = token.replace(/%25F/g, '%252F');
      token = token.replace(/%3D/g, '=');
      return  token.replace(/%2B/g, '+');
  } 

  encriptar(texto) 
  {
    var keyHex = CryptoJS.enc.Utf8.parse(this.key);
    var ivHex = CryptoJS.enc.Hex.parse(CryptoJS.enc.Utf8.parse(this.iv).toString(CryptoJS.enc.Hex));
    var encrypted = CryptoJS.DES.encrypt(texto, keyHex, { iv: ivHex, mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.ZeroPadding });
    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
  }

  desencriptar(texto)
  {
    var keyHex = CryptoJS.enc.Utf8.parse(this.key);
    var ivHex = CryptoJS.enc.Hex.parse(CryptoJS.enc.Utf8.parse(this.iv).toString(CryptoJS.enc.Hex));  
    let decrypt = CryptoJS.DES.decrypt(texto.toString(), keyHex, { iv: ivHex, mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.ZeroPadding });
    return decrypt.toString(CryptoJS.enc.Utf8);
  }

  encodeBase64(texto: string)
  {
    if(texto != "")
    {
      let wordArray = CryptoJS.enc.Utf8.parse(texto);
      let base64 = CryptoJS.enc.Base64.stringify(wordArray);
      base64 = encodeURIComponent(base64);
      base64 = base64.replace(/%2F/g, '%252F');
      base64 = base64.replace(/%25F/g, '%252F');
      base64 = base64.replace(/%3D/g, '=');
      return   base64.replace(/%2B/g, '+');
    }

    return texto;
  }

  generarMd5(texto: string)
  {
    return CryptoJS.MD5(texto).toString();
  }

  esUnaCadenaMd5(s) 
  {
    return s.match("^[a-fA-F0-9]{32}$");
  }
}
